import React from "react";
import { Link } from "react-router-dom";



const AppMembJoinLink = ({membJoinLinkTxt}:any) => {
    return(
        <>
        <div className="membJoinLinkWrap">
            <ul>
                <li>
                    <Link to="/Connect/MembFindId" replace>
                        <p>{membJoinLinkTxt[0]}</p>
                    </Link>
                </li>
                <li>
                    <Link to="/Connect/MembFindPw" replace>
                        <p>{membJoinLinkTxt[1]}</p>
                    </Link>
                </li>
                <li>
                    <Link to="/Connect/MembJoin" replace>
                        <p>{membJoinLinkTxt[2]}</p>
                    </Link>
                </li>
            </ul>
        </div>
        </>
    )
}

export default AppMembJoinLink;

